import { useMutation, useQueryClient } from "react-query";
import { updateClient } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";
import { GET_CLIENTS } from "@constants/reactQueryKeys";

interface UpdateClientPayload {
  clientId: string;
  data: Record<string, any>;
}

export const useUpdateClient = (options: any = {}) => {
  const { onSuccess = () => {}, onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();
  const queryClient = useQueryClient();

  const { mutate, isLoading, ...rest } = useMutation(
    (payload: UpdateClientPayload) => updateClient(payload),
    {
      onSuccess: (response, variables) => {
        showToast({ message: "Client information updated successfully." });

        queryClient.invalidateQueries([GET_CLIENTS]);

        onSuccess(response, variables);
      },
      onError: (error: any) => {
        const errorMessage =
          error?.response?.data?.error || "Failed to update client information";
        showToast({ message: errorMessage, errorState: true });
        onError(error);
      },
      ...otherOptions,
    }
  );

  return { updateClient: mutate, isUpdating: isLoading, ...rest };
};
